import React from 'react';
import { Typography } from '@mui/material';
import { ListView } from '../../components';
import { quizList } from '../../config/layouts/quiz';

export const QuizList = () => {
  const objListActions: JSX.Element[] = [];

  const props = {
    title: quizList.title,
    tableProps: {
      columns: quizList.columns,
      emptyMessage: <Typography>{quizList.emptyMessage} </Typography>,
    },
    apiRequest: quizList.apiRequest,
    actions: objListActions,
  };
  return <ListView {...props} />;
};
